var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "module dt-relative lyw" }, [
    _vm.playlist.length > 0
      ? _c("h3", [
          _vm._v(
            "\n    本片播放源（共" + _vm._s(_vm.playlist.length) + "个）\n  "
          ),
        ])
      : _c("h3", [_vm._v("\n    本片播放源（暂无）\n  ")]),
    _vm._v(" "),
    _vm.playlist.length > 0
      ? _c(
          "ul",
          { staticClass: "dt-relative-wrap" },
          _vm._l(_vm.playlist, function (value, index) {
            return _c("li", { key: index }, [
              _c(
                "a",
                {
                  attrs: {
                    href: value.playUrl,
                    uigs: "moviepy_out_list_video_" + index,
                    uigsparams: `play_type=video&play_url=${encodeURIComponent(
                      value.ourl
                    )}&play_site=${value.domain}`,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "dt-relative-item-img" },
                    [
                      _c("Image-1", { attrs: { src: value.picurl, alt: "" } }),
                      _vm._v(" "),
                      value.duration && value.duration !== 0
                        ? _c("span", { staticClass: "tag-play" }, [
                            _vm._v(_vm._s(_vm.formatDuration(value.duration))),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dt-relative-item-info simple" }, [
                    _c("p", [
                      value.icon
                        ? _c("img", {
                            staticClass: "icon-sp",
                            attrs: {
                              src: _vm.item.imgpath + "/logo/" + value.icon,
                              alt: "",
                            },
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n            " +
                          _vm._s(value.siteName) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]
              ),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }